import { createFileRoute, redirect } from '@tanstack/react-router'
import SignupPage from '@/views/signup'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/signup')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: SignupPage,
})